export const callFlutterHandler = (action, payload = {}) => {
  try {
    return window.flutter_inappwebview.callHandler(
      'Flutter',
      JSON.stringify({ action, ...payload }),
    );
  } catch (err) {
    console.log(`catch error :- ${err}`);
  }
};

export const callFlutterExternalLinkHandler = (action, payload = {}) => {
  try {
    return window.flutter_inappwebview.callHandler(
      'Flutter',
      JSON.stringify({ action, ...payload }),
    );
  } catch (err) {
    console.log(`catch error :- ${err}`);
  }
};
